function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_8_mobile_design_for_pioneer_svg__cls-2{fill:none;stroke:#81858d;stroke-miterlimit:10;stroke-width:.76px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon_8_mobile_design_for_pioneer_svg__icon_8_mobile_design_for_pioneer"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_8_mobile_design_for_pioneer_svg___\\u043B\\u043E\\u0439_25"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 0H2C.9 0 0 .91 0 2.03v13.94C0 17.09.9 18 2 18h19c1.1 0 2-.91 2-2.03V2.03C23 .91 22.1 0 21 0zm-1.3 14c0 1.14-.91 2.06-2.03 2.06H4.04c-1.12 0-2.03-.92-2.03-2.06V4c0-1.14.91-2.06 2.03-2.06h13.62c1.12 0 2.03.92 2.03 2.06v10zm2.06-4.62h-1v-.76h1v.76z",
  fill: "#81858d"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_8_mobile_design_for_pioneer_svg__cls-2",
  d: "M4.07 13.22l4.9-5.15 2.63 2.69 1.76-1.95 4.28 4.42"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon_8_mobile_design_for_pioneer_svg__cls-2",
  x: 3.88,
  y: 2.92,
  width: 13.95,
  height: 12.17,
  rx: 2.55,
  ry: 2.55
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "icon_8_mobile_design_for_pioneer_svg__cls-2",
  cx: 15.07,
  cy: 5.84,
  rx: 1.21,
  ry: 1.22
})));

var SvgIcon8Mobiledesignforpioneer = function SvgIcon8Mobiledesignforpioneer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_8_mobile_design_for_pioneer_svg___023_Q4",
    viewBox: "0 0 23 18"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJfMDIzX1E0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMyAxOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MTg1OGQ7fS5jbHMtMntmaWxsOm5vbmU7c3Ryb2tlOiM4MTg1OGQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOi43NnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iaWNvbl84X21vYmlsZV9kZXNpZ25fZm9yX3Bpb25lZXIiPjxnIGlkPSJf0LvQvtC5XzI1Ij48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMSwwSDJDLjksMCwwLC45MSwwLDIuMDNWMTUuOTdjMCwxLjEyLC45LDIuMDMsMiwyLjAzSDIxYzEuMSwwLDItLjkxLDItMi4wM1YyLjAzYzAtMS4xMi0uOS0yLjAzLTItMi4wM1ptLTEuMywxNGMwLDEuMTQtLjkxLDIuMDYtMi4wMywyLjA2SDQuMDRjLTEuMTIsMC0yLjAzLS45Mi0yLjAzLTIuMDZWNGMwLTEuMTQsLjkxLTIuMDYsMi4wMy0yLjA2aDEzLjYyYzEuMTIsMCwyLjAzLC45MiwyLjAzLDIuMDZWMTRabTIuMDYtNC42MmgtMXYtLjc2aDF2Ljc2WiIvPjxnPjxwb2x5bGluZSBjbGFzcz0iY2xzLTIiIHBvaW50cz0iNC4wNyAxMy4yMiA4Ljk3IDguMDcgMTEuNiAxMC43NiAxMy4zNiA4LjgxIDE3LjY0IDEzLjIzIi8+PHJlY3QgY2xhc3M9ImNscy0yIiB4PSIzLjg4IiB5PSIyLjkyIiB3aWR0aD0iMTMuOTUiIGhlaWdodD0iMTIuMTciIHJ4PSIyLjU1IiByeT0iMi41NSIvPjxlbGxpcHNlIGNsYXNzPSJjbHMtMiIgY3g9IjE1LjA3IiBjeT0iNS44NCIgcng9IjEuMjEiIHJ5PSIxLjIyIi8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgIcon8Mobiledesignforpioneer as ReactComponent };